import * as React from 'react';
import type { HeroBlockViewModel } from '../ViewModel/HeroBlockViewModel.csharp';
import { Hero } from '~/Partials/Hero/Hero';

export const HeroBlock: React.FC<HeroBlockViewModel> = props => {
    const { heading, intro, headingSize, variant, image, videoUrl, breadcrumbs } = props;

    return (
        <Hero
            colorVariant={variant}
            heading={heading}
            headingSize={headingSize}
            description={intro}
            breadcrumbs={breadcrumbs}
            image={image}
            video={videoUrl}
            caption={image?.caption}
            author={image?.author}
        />
    );
};
